var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a-collapse-transition',[_c('client-only',[(_vm.ebookData)?_c('a-ebook',_vm._g(_vm._b({},'a-ebook',_vm.ebookProps,false),_vm.$listeners)):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }